import LoadingIcon from "../../../common/LoadingIcon";
import {
  FlashPCBTable,
  Input,
  SelectableTableRow,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
} from "../../../../constants/Styles";
import React, { Dispatch, SetStateAction, SyntheticEvent } from "react";
import { FootprintSummary } from "../../../FootprintSummary";
import RadioButton from "../../../common/RadioButton";
import Button from "../../../common/Button";
import { FootprintSearchForm } from "./FootprintListStyles";
import { useStringInput } from "../../../../utils/hooks/inputs";
import useSearchFootprints from "../../../../utils/hooks/footprints/searchFootprints";
import LoadingOverlay from "../../../LoadingOverlay";
import Pagination from "../../../Pagination";
import { ButtonTypes } from "../../../common/Button/constants";

export default function FootprintList({
  selectedFootprintId,
  setSelectedFootprintId,
}: {
  selectedFootprintId: string | null;
  setSelectedFootprintId: Dispatch<SetStateAction<string | null>>;
}) {
  const { setSearchTerm, searching, footprintsResponse, setPage } =
    useSearchFootprints();
  const { value: searchTermInput, bind: bindSearchTermInput } =
    useStringInput("");

  if (footprintsResponse === null) {
    return <LoadingIcon text={"Loading footprints..."} />;
  }

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();
    setSearchTerm(searchTermInput);
    setPage(1);
  };

  return (
    <>
      <LoadingOverlay loading={searching} text={"Searching footprints..."} />
      <FootprintSearchForm onSubmit={handleSubmit}>
        <Input placeholder={"Search footprints"} {...bindSearchTermInput} />
        <Button type={ButtonTypes.SUBMIT} label={"Search"} />
      </FootprintSearchForm>
      <FlashPCBTable>
        <thead>
          <TableHeaderRow>
            <TableHeaderCell />
            <TableHeaderCell>Name</TableHeaderCell>
            <TableHeaderCell>Preview</TableHeaderCell>
          </TableHeaderRow>
        </thead>
        <tbody>
          {footprintsResponse.footprints.map((footprint) => {
            const selectFootprint = () => setSelectedFootprintId(footprint.id);
            const footprintIsSelected = footprint.id == selectedFootprintId;
            return (
              <SelectableTableRow
                key={footprint.id}
                onClick={selectFootprint}
                selected={footprintIsSelected}
              >
                <TableCell>
                  <RadioButton
                    onChange={selectFootprint}
                    checked={footprintIsSelected}
                  />
                </TableCell>
                <TableCell>{footprint.name}</TableCell>
                <TableCell>
                  <FootprintSummary footprint={footprint} />
                </TableCell>
              </SelectableTableRow>
            );
          })}
        </tbody>
      </FlashPCBTable>
      <Pagination
        page={footprintsResponse.page}
        startingIndex={footprintsResponse.starting_index}
        totalCount={footprintsResponse.total_count}
        itemsPerPage={footprintsResponse.count_per_page}
        itemsOnPage={footprintsResponse.footprints.length}
        onBackAction={() => setPage(footprintsResponse.page - 1)}
        onForwardAction={() => setPage(footprintsResponse.page + 1)}
        disabled={searching}
      />
    </>
  );
}
